import { DateTime } from 'luxon';

/**
 * Pure UTC<->calendar-day helpers shared by the date-range filter.
 *
 * The picker works in calendar days; the backend stores UTC epoch seconds. These
 * convert between the two without shifting the day (the ENG-2797 off-by-one), by
 * always reading the local calendar Y/M/D and pinning the timestamp to UTC.
 */

/** UTC epoch seconds -> a local Date at the same calendar Y/M/D (seeds the picker). */
export const secondsToCalendarDate = (seconds: number): Date => {
  const utc = DateTime.fromSeconds(seconds, { zone: 'utc' });
  return new Date(utc.year, utc.month - 1, utc.day);
};

/** A picked calendar day -> UTC start-of-day epoch seconds. */
export const startSeconds = (date: Date): number => {
  const d = DateTime.fromJSDate(date);
  return Math.floor(DateTime.utc(d.year, d.month, d.day).toSeconds());
};

/** A picked calendar day -> UTC end-of-day (23:59:59) epoch seconds. */
export const endSeconds = (date: Date): number => {
  const d = DateTime.fromJSDate(date);
  return Math.floor(DateTime.utc(d.year, d.month, d.day).endOf('day').toSeconds());
};

/** UTC epoch seconds -> MM/dd/yyyy label. */
export const formatSeconds = (seconds: number): string =>
  DateTime.fromSeconds(seconds, { zone: 'utc' }).toFormat('MM/dd/yyyy');
